import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Typography from "@material-ui/core/Typography";
import InfoIconComponent from "../../../../forms/tradeplans/tradingPlanFormComponents/FieldComponents/InfoIcon";
import WorkOrdersDoc from "../../../../forms/tradeplans/documentation/WorkOrderDocumentation";
import Grid from "@material-ui/core/Grid";
import React from "react";
import StyledCheckbox from "../../../../../utils/componentutils/StyledCheckbox";

export default function WorkOrderComponent({top, dispatchTop}) {
    return <FormControlLabel
        value="top"
        control={
            <StyledCheckbox
                color="primary"
                checked={top.workOrders}
                onChange={(ev) =>
                    dispatchTop({workOrders: ev.target.checked})
                }
            />
        }
        label={<Typography style={{fontSize: 10}}>WorkOrders</Typography>}
        labelPlacement="bottom"
    />
}